import './SiteLayoutAlert.scss';
import React from 'react';

export const SiteLayoutAlert = ({ children }) => {
    return <div className="site-layout__alert">{children}</div>;
};
